// extracted by mini-css-extract-plugin
export default {"background":"LearningIcon_background__7y1c-","path":"LearningIcon_path__3STrI","dot":"LearningIcon_dot__0P91s"};